module.exports = __webpack_public_path__ + "static/media/celular.dc6268bd.svg";